import { create } from 'zustand';

const useEmissionStore = create((set) => ({
  selectedEmission: null,
  setSelectedEmission: (emission) => set({ selectedEmission: emission }),
  clearSelectedEmission: () => set({ selectedEmission: null }),
}));

export default useEmissionStore;
